document.querySelectorAll('.s-tabs').forEach(function (section) {
    section.querySelectorAll('.s-tabs__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
            tabClick(tab, section);
        });
    });

    const imgElement = section.querySelectorAll('img.size-s-media__image');
    imgElement.forEach(function (image) {
        if (image.loading === 'lazy') {
            image.addEventListener('load', () => {
                tabsResize(section);
            });
        }
    });
});

window.addEventListener('resize', function () {
    document.querySelectorAll('.s-tabs').forEach(function (section) {
        tabsResize(section);
    });
});

function tabClick(tab, section) {
    const index = Array.prototype.indexOf.call(tab.closest('.s-tabs__tabs').querySelectorAll('.s-tabs__tab'), tab);
    const container = section.querySelector('.c-list-expandable');
    const newTab = section.querySelectorAll('.c-list-expandable__item')[index];

    tab.closest('.s-tabs__tabs').querySelector('.active').classList.remove('active');
    tab.classList.add('active');

    container.querySelector('.active').classList.remove('active');
    newTab.classList.add('active');

    if (window.innerWidth < 992) {
        container.style.height = newTab.offsetHeight + 'px';
    }
    tabsResize(section);
}

function tabsResize(section) {
    if (window.innerWidth > 991) {
        const items = section.querySelectorAll('.c-list-expandable__item');
        let maxHeight = 0;

        items.forEach(function (item) {
            maxHeight = Math.max(maxHeight, item.offsetHeight);
        });

        section.querySelector('.c-list-expandable').style.height = maxHeight + 'px';
    } else {
        document.querySelectorAll('.s-tabs .c-list-expandable').forEach(function (el) {
            el.style.height = 'auto';
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/routes/sections/tabs.js